@use "@fukuri-admins/ui/layout" as *;

.Header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  border-bottom: 1px solid $Border;
  padding-bottom: 16px;
  &__TitleContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  &__Title {
    font-weight: 500;
    font-size: 32px;
  }
  &__Description {
    font-size: 14px;
    color: $TextLabel;
  }
  &__Actions {
    display: flex;
    justify-content: center;
    gap: 8px;
  }
}
